import Vue from 'vue';

const success = (response, context) => {
  context.path = response.data.path;
  const a = document.createElement('a');
  a.href = context.path;
  a.download = 'download';
  a.click();
  context.loading = false;
};

const failed = (error, context) => {
  context.showToasterError(error);
  context.loading = false;
};

export default context => Vue.$http.get(`/export-ics/${context.$route.params.permalink}`)
  .then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }
  })
  .catch((error) => {
    failed(error, context);
  });



// WEBPACK FOOTER //
// ./src/app/services/booking/exportIcs.js